import { render, staticRenderFns } from "./MyVoicesModal.vue?vue&type=template&id=27505442&scoped=true"
import script from "./MyVoicesModal.vue?vue&type=script&lang=js"
export * from "./MyVoicesModal.vue?vue&type=script&lang=js"
import style0 from "./MyVoicesModal.vue?vue&type=style&index=0&id=27505442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27505442",
  null
  
)

export default component.exports